import Api from "./api";

class FeedbacksService {

    api = new Api();

    getFeebacks() {
        return this.api.post('/admin/feedbacks/get-feedbacks');
    }

    checkFeedback(feedbackId) {
        return this.api.post('/admin/feedbacks/check-feedback',{
           feedbackId: feedbackId
        });
    }

    getTypes() {
        return this.api.post('/admin/feedbacks/get-types');
    }

    createFeedback(type, message) {
        return this.api.post('/admin/feedbacks/create-feedback',{
           type: type,
           message: message
        });
    }

    remove(feedback) {
        return this.api.post('/admin/feedbacks/remove-feedback',{
            feedback: feedback
        });
    }

    changeFeedback(feedback) {
        return this.api.post('/admin/feedbacks/change-feedback',{
            feedback:feedback
        });
    }

    changeStatus(id) {
        return this.api.post('/admin/feedbacks/change-status',{
            id:id
        });
    }

}

export default new FeedbacksService();